export default __webpack_public_path__ + "static/1256-45f50fdaad27b4dbbd1d419070ffbba0.gif";